import { render, staticRenderFns } from "./NewMessengerConversationItem.vue?vue&type=template&id=3002f1c4&scoped=true"
import script from "./NewMessengerConversationItem.vue?vue&type=script&lang=js"
export * from "./NewMessengerConversationItem.vue?vue&type=script&lang=js"
import style0 from "./NewMessengerConversationItem.vue?vue&type=style&index=0&id=3002f1c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3002f1c4",
  null
  
)

export default component.exports